// extracted by mini-css-extract-plugin
module.exports = {"guarantee":"Guarantee_guarantee__2ZEMU","icon":"Guarantee_icon__dOFqj","label":"Guarantee_label__89qHq"};